// // PublicRoute.js
// import React, { useEffect } from "react";
// import { Navigate, useNavigate } from "react-router-dom";
// import { useSelector, useDispatch } from "react-redux";
// import { updateTokens, logoutUser } from "../redux/slices/userSlice";
// import axiosAuthService from "../utilities/api/axios";
// import AdminUserDetail from "../utilities/api/user/AdminUserDetail";

// const PublicRoute = ({ children }) => {
//     const { access, refresh, user } = useSelector((state) => state.user.user);
//     const dispatch = useDispatch();
//     const navigate = useNavigate();

//     useEffect(() => {
//         const validateToken = async () => {
//             if (access) {
//                 try {
//                     // Attempt to validate token by calling StudentDetailGet
//                     const response = await AdminUserDetail.AdminDetailGet(user.id);
//                     console.log('Response:', response);
//                     if (response) {
//                         // Token is valid; redirect to dashboard
//                         navigate("/dashboard");
//                     }
//                 } catch (error) {
//                     if (error.response && error.response.status === 401) {
//                         // Unauthorized response, try refreshing the token
//                         try {
//                             const refreshResponse = await axiosAuthService.post("refresh/", { refresh });
//                             dispatch(updateTokens(refreshResponse.data.access));
//                             // Retry validation with new access token
//                             const retryResponse = await AdminUserDetail.AdminDetailGet(user.id);
//                             if (retryResponse) {
//                                 navigate("/dashboard");
//                             }
//                         } catch (refreshError) {
//                             // If token refresh fails, log out the user
//                             dispatch(logoutUser());
//                             navigate("/login");
//                         }
//                     }
//                 }
//             }
//         };

//         validateToken();
//     }, [access, refresh, dispatch, navigate]);

//     // Render children if no redirection occurs
//     return <>{children}</>;
// };

// export default PublicRoute;

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateTokens, logoutUser } from '../redux/slices/userSlice';
import axiosAuthService from '../utilities/api/axios';
import AdminUserDetail from '../utilities/api/user/AdminUserDetail';
import { useNavigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
  const { access, refresh, user } = useSelector(state => state.user.user || {});
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const validateToken = async () => {
      // Only proceed if we have both access token and user ID
      if (!access || !user?.id) {
        return;
      }

      try {
        const response = await AdminUserDetail.AdminDetailGet(user.id);
        if (response) {
          navigate('/dashboard');
        }
      } catch (error) {
        // Only attempt refresh if we have a valid refresh token
        if (error.response?.status === 401 && refresh) {
          try {
            const refreshResponse = await axiosAuthService.post('refresh/', {
              refresh,
            });
            dispatch(
              updateTokens({
                access: refreshResponse.data.access,
                refresh: refresh, // Keep the same refresh token
              })
            );
            navigate('/dashboard');
          } catch (refreshError) {
            dispatch(logoutUser());
            navigate('/login');
          }
        }
      }
    };

    validateToken();
  }, [access, refresh, user?.id, dispatch, navigate]);

  return <>{children}</>;
};

export default PublicRoute;
